import { Link } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { TrackingLink } from '@/lib/marketing';

export function Footer() {
  const { user } = useAuth();

  return (
    <footer className="bg-[#00178E] dark:bg-[#000C33] text-white py-16 overflow-x-clip shrink-0">
      <div className="max-w-6xl mx-auto px-4 box-border">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                data-twic-src="media:images/logo/jd-simplified-logo-dark.png?v=20260530"
                data-twic-transform="quality=95/output=auto"
                loading="lazy"
                alt="JD Simplified - Law School Study Platform Logo"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-4">
              JD Simplified is a study companion for law students, designed to help you understand the law, practice applying it, and focus on what matters most.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.youtube.com/@JDsimplified" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" aria-label="YouTube">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">Home</Link>
              </li>
              <li>
                <TrackingLink href="/auth" campaign="footer" content="sign_in" className="text-gray-300 hover:text-white transition-colors">Sign In</TrackingLink>
              </li>
              <li>
                <TrackingLink href="/auth?tab=signup" campaign="footer" content="sign_up" className="text-gray-300 hover:text-white transition-colors">Sign Up</TrackingLink>
              </li>
              <li>
                <a href="http://refer.jdsimplified.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  Refer a Friend
                </a>
              </li>
              <li>
                <a href="https://roadmap.jdsimplified.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  Roadmap
                </a>
              </li>
              <li>
                <TrackingLink href="/features/outlines" campaign="footer" content="outlines" className="text-gray-300 hover:text-white transition-colors">Outlines</TrackingLink>
              </li>
              {user && (
                <>
                  <li>
                    <TrackingLink href="/chat" campaign="footer" content="chat" className="text-gray-300 hover:text-white transition-colors">Chat</TrackingLink>
                  </li>
                  <li>
                    <TrackingLink href="/settings" campaign="footer" content="settings" className="text-gray-300 hover:text-white transition-colors">Settings</TrackingLink>
                  </li>
                </>
              )}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <TrackingLink href="/terms" campaign="footer" content="terms" className="text-gray-300 hover:text-white transition-colors">Terms of Service</TrackingLink>
              </li>
              <li>
                <TrackingLink href="/privacy" campaign="footer" content="privacy" className="text-gray-300 hover:text-white transition-colors">Privacy Policy</TrackingLink>
              </li>
              <li>
                <TrackingLink href="/disclaimer" campaign="footer" content="disclaimer" className="text-gray-300 hover:text-white transition-colors">Disclaimer</TrackingLink>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-blue-800 dark:border-blue-900/50 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-300 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} JD Simplified, LLC. All rights reserved.
          </p>
          <p className="text-gray-300 text-sm">
            Made with ❤️ for law students everywhere
          </p>
        </div>
      </div>
    </footer>
  );
}
